import { SuccessResponse } from "common/common.interface";
import { environment } from "common/environment";
import {
    AuthenticatedUser,
    ISignInWithUserPasswordPayload,
    SetPasswordPayload,
    WorkspaceUserState,
} from "modules/auth/types/auth.interface";

export interface IAuthBackend {
  signInWithEmailPassword: ({
    email,
    password,
  }: ISignInWithUserPasswordPayload) => Promise<AuthenticatedUser>;
  sendResetPassword: (email: string) => Promise<SuccessResponse>;
  getUserState: (email: string) => Promise<SuccessResponse<WorkspaceUserState>>;
  verifyCode: (code: string) => Promise<SuccessResponse>;
  setPassword: (payload: SetPasswordPayload) => Promise<SuccessResponse>;
  resendSetPassword: (email: string) => Promise<SuccessResponse>;
}

let authBackendInstance: IAuthBackend | undefined;

export async function getAuthBackend(): Promise<IAuthBackend> {
  if (authBackendInstance === undefined) {
    const mod = await import(`./${environment.AUTH_BACKEND}`);
    authBackendInstance = new mod.default() as IAuthBackend;
  }
  return authBackendInstance;
}
